import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import moment from 'moment';

import Color from './Color';

import { isSameDay } from './utils';
import { DATE_FORMAT } from './Constant';
import LocaleContext from './locale_context';

export default function Day({
  dateFormat = DATE_FORMAT,
  currentMessage = { createdAt: null },
  previousMessage = {},
  nextMessage = {},
  containerStyle = {},
  wrapperStyle = {},
  textStyle = {},
  inverted = true,
}) {
  if (!isSameDay(currentMessage, inverted ? previousMessage : nextMessage)) {
    const context = useContext(LocaleContext);
    return (
      <View style={[styles.container, containerStyle]}>
        <View style={wrapperStyle}>
          <Text style={[styles.text, textStyle]}>
            {moment(currentMessage.createdAt)
              .locale(context?.getLocale())
              .format(dateFormat)
              .toUpperCase()}
          </Text>
        </View>
      </View>
    );
  }
  return null;
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 5,
    marginBottom: 10,
  },
  text: {
    backgroundColor: Color.backgroundTransparent,
    color: Color.defaultColor,
    fontSize: 12,
    fontWeight: '600',
  },
});
